import React from 'react'
import YnsIcon from '../icons/YnsIcon'
import useTranslation from '../shared/TranslationProvider'
import { cn } from '~/lib/utils'
import useCareerExploration from './CareerExplorationProvider'

const ResultsSection = ({ className, section, children, eleRef, ...props }) => {
  return (
    <div ref={eleRef} className={cn('', className)}>
      <ResultsHeading className={'mb-2'} section={section} {...props} />
      {children}
    </div>
  )
}
export default ResultsSection

export const ResultsHeading = ({
  className,
  section,
  isToc,
  career,
  ...props
}) => {
  const { getSectionTitle } = useCareerExploration()
  const { t } = useTranslation(section)
  const icon = t('icon')
  const { occupation, reported_title } = career
  const title = reported_title?.reported_job_title || occupation.title
  const sectionTitle = getSectionTitle(isToc, t, title)
  return (
    <div className={cn('flex gap-2', className)} {...props}>
      <YnsIcon name={icon} className={isToc ? 'text-black' : 'text-primary'} />
      <div
        className={
          isToc ? 'text-black hover:underline' : 'subtitle text-primary'
        }
      >
        {sectionTitle}
      </div>
    </div>
  )
}

export const NotAvailable = ({ ...props }) => {
  const { t } = useTranslation('Page')
  return (
    <ResultsSection {...props}>
      <div>{t('not_available')}</div>
    </ResultsSection>
  )
}
